import { useState } from "react"
import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipButton } from "@/v2-backoffice-client/components/button"
import LicenseFeatureGroupUpsertDialog from "@/v2-backoffice-client/license/featureGroup/LicenseFeatureGroupUpsertDialog"
import type { FeatureGroupFragment } from "@/v2-backoffice-client/license/featureGroup/__types__/license.featureGroup.fragment"

export type LicenseFeatureGroupViewToolbarProps = ComponentProps<"div"> & {
  featureGroup: FeatureGroupFragment | null | undefined
}

// Identity edit only (name/code/description — same dialog as the board's row
// menu). What the package bundles is the Features tab's job, and deleting
// stays in the row menu next to the list it removes from.
function LicenseFeatureGroupViewToolbar(
  props: LicenseFeatureGroupViewToolbarProps,
) {
  const { featureGroup, ...viewSheetToolbarProps } = props
  const [isEditOpen, setIsEditOpen] = useState(false)
  if (!featureGroup) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <TooltipButton
        variant="ghost"
        isStacked
        iconSrc="edit"
        content="Rename the package or reword what it stands for — its identity, not its contents"
        onClick={() => {
          setIsEditOpen(true)
        }}
      >
        Update
      </TooltipButton>

      <LicenseFeatureGroupUpsertDialog
        featureGroup={featureGroup}
        open={isEditOpen}
        onOpenChange={setIsEditOpen}
      />
    </ViewSheet.Toolbar>
  )
}

export default LicenseFeatureGroupViewToolbar
